import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { verbalReceived } from '@mummssoftware/utils/medications/utils';
import { styles } from '../../../utils/styles';
export const MedVerbalPDF = ({
  med
}) => /*#__PURE__*/React.createElement(View, {
  style: [styles.width16, styles.paddingRightPointOneCm]
}, /*#__PURE__*/React.createElement(Text, {
  style: styles.medsTableMainDetailsText
}, `${verbalReceived(med)}`));